// src/auth/utils.ts
import awsconfig from '../../aws-exports';
import { jwtVerify, createRemoteJWKSet } from 'jose';
//import type { JWTVerifyResult } from 'jose';
import {  COGNITO_CLIENT_ID } from './config'//'  ./config';
import { CustomSession } from '../../features/userTokenManagementSlice';
export const JWKS_URI = `${awsconfig.authority}/.well-known/jwks.json`;
// Define the shape of your custom session data
// export interface CustomSession {
//     id_token?: string;
//     access_token?: string;
//     refresh_token?: string;
//     expires_at: number; // Unix timestamp for access token expiry
//     profile: any; // Decoded user profile/claims
// }

const JWKS = createRemoteJWKSet(new URL(JWKS_URI));

/**
 * Validates a JWT (ID Token or Access Token) using jose against the Cognito JWKS.
 * @param token The JWT string to validate.
 * @param tokenUse Expected token usage ('id' or 'access').
 */
export async function validateCognitoToken(token: string, tokenUse: 'id' | 'access'): Promise<any> {
    try {
        const result = await jwtVerify(token, JWKS, {
            // These claims must match your Cognito setup for validation to pass
            issuer: awsconfig.authority,//`https://cognito-idp.${COGNITO_REGION}.amazonaws.com/${COGNITO_USER_POOL_ID}`,
            audience: COGNITO_CLIENT_ID,
            // Check for the correct 'token_use' claim
            // NOTE: Cognito uses 'id' for ID Tokens and 'access' for Access Tokens
            subject: tokenUse, 
        });

        // Additional custom claim checks can go here if needed

        return result;
    } catch (error) {
        console.error('JWT Validation Failed:', error);
        throw new Error('Token signature or claims are invalid.');
    }
}


// --- Local Storage Management ---

const SESSION_KEY = 'sms_auth_session';
const METHOD_KEY = 'active_auth_method';
export const CUSTOM_METHOD = 'sms-cognito';
export const HOSTED_UI_REDIRECT = 'hosted-ui-redirect';

export const storage = {
    // Check for the custom flow marker
    isCustomFlowActive: (): boolean => 
        localStorage.getItem(METHOD_KEY) === CUSTOM_METHOD,

    // Load session data
    loadSession: (): CustomSession | null => {
        const data = localStorage.getItem(SESSION_KEY);
        if (!data || !storage.isCustomFlowActive()) return null;
        try {
            //need to check if the user/tokens have been deleted
            return JSON.parse(data) as CustomSession;
        } catch {
            return null;
        }
    },

    // Save session data and the method marker
    saveSession: (session: CustomSession) => {
        localStorage.setItem(SESSION_KEY, JSON.stringify(session));
        localStorage.setItem(METHOD_KEY, CUSTOM_METHOD);
    },

    // Clear everything related to the custom session
    clearSession: () => {
        localStorage.removeItem(SESSION_KEY);
        localStorage.removeItem(METHOD_KEY);
    },
};